<template>
    <div v-if="chartData.length != undefined && chartData.length > 1 && chartData.length != null">
        
        <div v-if="reportType == 'Invoiced ROs'">
            <GChart class="mb-15" type="ColumnChart" :data="chartData" :options="chartOptions"/>
            <div class="row">
                <div v-for="item in invoicedROsData" :key="item.title" class="col-sm-6">
                    <div class="card box-shadow mb-15">
                        <div class="card-body">
                        <h5 class="card-title mb-0">
                            <i class="fp-truck-asset"></i> &nbsp;{{ item.title }} <span class="pull-right font-bold">{{ item.value }}</span>
                        </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="reportType == 'Expected ROs'">
            <GChart class="mb-15" type="ColumnChart" :data="chartData" :options="chartOptions"/>
            <div class="row">
                <div v-for="item in expectedROsData" :key="item.title" class="col-sm-6">
                    <div class="card box-shadow mb-15">
                        <div class="card-body">
                        <h5 class="card-title mb-0">
                            <i class="fp-truck-asset"></i> &nbsp;{{ item.title }} <span class="pull-right font-bold">{{ item.value }}</span>
                        </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="reportType == 'Cycle Time'">
            <GChart class="mb-15" type="ColumnChart" :data="chartData" :options="chartOptions"/>
            <div class="row">
                <div v-for="item in cycleTimeData" :key="item.title" class="col-sm-6">
                    <div class="card box-shadow mb-15">
                        <div class="card-body">
                        <h5 class="card-title mb-0">
                            <i class="fp-truck-asset"></i> &nbsp;{{ item.title }} <span class="pull-right font-bold">{{ item.value }}</span>
                        </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="reportType == 'Expected vs Actual Finish Time'">
            <GChart class="mb-15" type="ColumnChart" :data="chartData" :options="chartOptionsB"/>
            <div class="row">
                <div v-for="item in expVsActFinishData" :key="item.title" class="col-sm-6">
                    <div class="card box-shadow mb-15">
                        <div class="card-body">
                        <h5 class="card-title mb-0">
                            <i class="fp-truck-asset"></i> &nbsp;{{ item.title }} <span class="pull-right font-bold">{{ item.value }}</span>
                        </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="reportType == 'Dwell Time'">
            <GChart class="mb-15" type="ColumnChart" :data="chartData" :options="chartOptions"/>
            <div class="row">
                <div v-for="item in dwellTimeData" :key="item.title" class="col-sm-6">
                    <div class="card box-shadow mb-15">
                        <div class="card-body">
                        <h5 class="card-title mb-0">
                            <i class="fp-truck-asset"></i> &nbsp;{{ item.title }} <span class="pull-right font-bold">{{ item.value }}</span>
                        </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div v-else>
        <span>No data Found</span>
    </div>
</template>


<script>
import Vue from "vue";
import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import { GChart } from 'vue-google-charts/legacy';
import {commonMixins} from '../../mixins/commonMixins';

export default ({
    components: {
        appFooter: () => import('@/components/Footer'),
        GChart
    },
    props: {
        fromModule: {
            type: Object,
            required: false,
            default: undefined
        },
    },
    computed: {
        invoicedROsData(){
            return [
            {
                title: 'Total Amount',
                value: this.totalAmount
            },
            {
                title: 'Average Amount',
                value: this.averageAmount
            },
            {
                title: 'RO Count',
                value: this.roCount
            },
            {
                title: 'Paid Count',
                value: this.paidCount
            }
            ];
        },
        expectedROsData() {
            return [
            {
                title: 'RO Count',
                value: this.roCount
            },
            {
                title: 'Total Amount',
                value: this.totalAmount
            },
            {
                title: 'Unfinished Count',
                value: this.unfinishedCount
            },
            {
                title: 'Past Expected Finish',
                value: this.pastExpectedFinish
            }
            ];
        },
        cycleTimeData() {
            return [
            {
                title: 'Total Cycle Time',
                value: this.totalCycleTime
            },
            {
                title: 'Average Cycle Time',
                value: this.averageCycleTime
            },
            {
                title: 'RO Count',
                value: this.roCount
            },
            {
                title: 'On Time',
                value: this.onTime
            }
            ];
        },
        expVsActFinishData() {
            return [
            {
                title: 'Total Deviation',
                value: this.totalDeviationTime
            },
            {
                title: 'Average Deviation',
                value: this.averageDeviationTime
            },
            {
                title: 'RO Count',
                value: this.roCount
            },
            {
                title: 'On Time',
                value: this.onTime
            }
            ];
        },
        dwellTimeData() {
            return [
            {
                title: 'Total Hours',
                value: this.dwellTotalHours
            },
            {
                title: 'Average Hours',
                value: this.dwellAverageHours
            },
            {
                title: 'RO Count',
                value: this.roCount
            },
            {
                title: 'Not Started',
                value: this.notStarted
            }
            ];
        },
    },
    watch:{
        
    },
    mixins:[commonMixins],
    data: () => ({
        totalAmount: 0,
        averageAmount: 0,
        roCount: 0,
        paidCount: 0,
        unfinishedCount: 0,
        pastExpectedFinish: 0,
        dwellTotalHours: 0,
        dwellAverageHours: 0,
        notStarted: 0,
        totalCycleTime: 0,
        averageCycleTime: 0,
        totalDeviationTime: 0,
        averageDeviationTime: 0,
        onTime: 0,
        
        chartData: [],
        chartOptions: {
            vAxis: { 
                format: '####', // year count without decimals
                viewWindow: {
                    min:0,
                },
            },
            hAxis: {
                format: '####', // year without decimals
            },
            chartArea: {
                left: 90, // Adjust the left spacing
                top: 50, // Adjust the top spacing
                width: '90%', // Adjust the width of the chart area
                height: '70%' // Adjust the height of the chart area
            },
            legend:'top',
            width: 900,
            height: 400,
            colors: ['#F5CC90']
        },
        chartOptionsB: {
            vAxis: { 
                format: '#### Hrs',
            },
            chartArea: {
                left: 90, // Adjust the left spacing
                top: 50, // Adjust the top spacing
                width: '90%', // Adjust the width of the chart area
                height: '70%' // Adjust the height of the chart area
            },
            legend:'top',
            width: 900,
            height: 400,
            colors: ['#F5CC90']
        },
        reportData:null,
        reportType:'',
    }),
    mounted: function() {
        let self = this;
        setTimeout(function () {
            self.getchartdata();
        }, 1000);
    },
    methods: {
        getchartdata(){
            let self = this;
            self.$parent.loading = true;
            
            if(self.fromModule!=null && self.fromModule!=undefined){
                self.reportData = self.fromModule;
                self.reportType = self.reportData.report_type.value;
            }

            let fields = {
                report_data:JSON.stringify(self.reportData),
            };

            $.ajax({
                url: process.env.ROOT_API + "/repair-orders-analytics/chart",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                crossDomain: true,
                success: function (data) {
                    if(data.content.chart_data != undefined){
                        self.chartData = data.content.chart_data;
                    }
                    if(data.content.counts != undefined){
                        self.handleCounts(data.content.counts);
                    }
                    self.$parent.loading = false;
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-reports');
                }
            });
        },
        handleCounts(counts){
            let self = this;
            if(self.reportType == 'Invoiced ROs'){
                self.totalAmount = counts.total_amount;
                self.averageAmount = counts.average_amount;
                self.roCount = counts.ro_count;
                self.paidCount = counts.paid_count;
            }
            if(self.reportType == 'Expected ROs'){
                self.roCount = counts.ro_count;
                self.totalAmount = counts.total_amount;
                self.unfinishedCount = counts.unfinished_count;
                self.pastExpectedFinish = counts.past_expected_finish;
            }
            if(self.reportType == 'Cycle Time'){
                self.totalCycleTime = counts.total_cycle_time;
                self.averageCycleTime = counts.average_cycle_time;
                self.roCount = counts.ro_count;
                self.onTime = counts.on_time;
            }
            if(self.reportType == 'Expected vs Actual Finish Time'){
                self.totalDeviationTime = counts.total_deviation_time;
                self.averageDeviationTime = counts.average_deviation_time;
                self.roCount = counts.ro_count;
                self.onTime = counts.on_time;
            }
            if(self.reportType == 'Dwell Time'){
                self.dwellTotalHours = counts.total_hours;
                self.dwellAverageHours = counts.average_hours;
                self.roCount = counts.ro_count;
                self.notStarted = counts.not_started;
            }
        },
    }
})
</script>



// WEBPACK FOOTER //
// src/components/dashboard/RepairOrderChart.vue